const mod = angular.module('app.person.constants', [])

.factory('PersonConstants', function (gettextCatalog) {
  class PersonConstants {
    constructor() {
      'ngInject';

      this.jobTitlePlurals = {
        'Dentist': gettextCatalog.getString('Hammaslääkärit'),
        'DentalHygienist': gettextCatalog.getString('Suuhygienistit'),
        'SpecialDentist': gettextCatalog.getString('Erikoishammaslääkärit'),
        'SpecialDoctor': gettextCatalog.getString('Erikoislääkärit'),
        'DentalTechnician': gettextCatalog.getString('Hammasteknikot'),
        'SpecialDentalTechnician': gettextCatalog.getString('Erikoishammasteknikot'),
      };
    }

    getJobTitlePlurals(job_type) {
      return this.jobTitlePlurals[job_type];
    }
  }

  return new PersonConstants();

});

export default mod.name;
